import { FC } from 'react';
import styled from 'styled-components';

import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { CardContainer } from '~src/modules/questions/components/shared.sc';

const LoadingCardContainer = styled.div`
  opacity: 1;
  background-color: ${({ theme }) => theme.white.a10};
  border-radius: 5px;
`;

const CardLoaderContainer = styled.div`
  background-color: ${({ theme }) => theme.white.a10};
  margin-top: 14rem;
`;

const LoadingCard: FC = () => (
  <LoadingCardContainer>
    <CardContainer>
      <CardLoaderContainer>
        <LoadingSpinner />
      </CardLoaderContainer>
    </CardContainer>
  </LoadingCardContainer>
);

export default LoadingCard;
